import { useEffect, useReducer, useRef } from "react"

const toggleReducer = (state: any, nextValue: any) => (typeof nextValue === "boolean" ? nextValue : !state)

export const useToggle = (initialValue: any) => {
  return useReducer(toggleReducer, initialValue)
}

export const usePrevious = (value: any) => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  })

  return ref.current
}
